<template>
    <div class="container">
        <van-form
            class="form"
            @submit="submit"
            input-align="right"
            error-message-align="right"
        >
            <van-field
                required
                clearable
                name="name"
                v-model.trim="formObjcet.name"
                label="姓名"
                :maxlength="50"
                placeholder="请输入办卡人姓名"
                :rules="rules.name"
            />

            <van-field
                required
                label="证件类型"
                :maxlength="50"
                readonly
                value="身份证"
            />

            <van-field
                required
                readonly
                clickable
                clearable
                name="idNo"
                v-model.trim="formObjcet.idNo"
                @touchstart.native.stop="showIdNo = true"
                label="证件号"
                placeholder="请输入办卡人证件号"
                :rules="rules.idNo"
            />

            <van-number-keyboard
                theme="custom"
                close-button-text="完成"
                v-model.trim="formObjcet.idNo"
                :show="showIdNo"
                extra-key="X"
                @blur="submitIdNo"
            />

            <van-field
                required
                readonly
                clickable
                name="nation"
                v-model="formObjcet.nation.name"
                @click="showNation = true"
                label="民族"
                placeholder="请选择办卡人民族"
                :rules="rules.nation"
            />

            <van-popup v-model="showNation" position="bottom">
                <van-picker
                    show-toolbar
                    value-key="name"
                    :columns="renderData.nation"
                    @confirm="nationSelected"
                    @cancel="showNation = false"
                />
            </van-popup>

            <van-field
                required
                clearable
                name="phone"
                v-model="formObjcet.phone"
                label="联系电话"
                placeholder="请输入办卡人联系电话"
                type="digit"
                :rules="rules.phone"
            />

            <van-field
                clearable
                name="address"
                v-model.trim="formObjcet.address"
                label="联系地址"
                :maxlength="100"
                placeholder="请输入办卡人联系地址"
            />

            <div class="tools">
                <van-button
                    round
                    block
                    size="small"
                    type="primary"
                    :loading="loading"
                    :disabled="loading"
                    native-type="submit"
                >
                    注册健康卡
                </van-button>
            </div>
        </van-form>

        <div class="remind-text">
            <div>温馨提示：</div>
            <div>1.请填写就诊人真实有效的信息</div>
        </div>
    </div>
</template>

<script>
import idValidator from 'id-validator';
import medicalCardApi from '@/api/medicalCardApi';

export default {
    data() {
        const rules = {
            name: [{ required: true, message: '请输入办卡人姓名' }],
            idNo: [
                { required: true, message: '请输入办卡人证件号' },
                {
                    validator(value) {
                        const Validator = new idValidator(),
                            idNoInfo = Validator.getInfo(value);
                        if (!idNoInfo) {
                            return false;
                        }
                    },
                    message: '请输入正确的证件号码'
                }
            ],
            phone: [
                { required: true, message: '请输入办卡人联系电话' },
                {
                    validator(value) {
                        if (!/^(1[3-9][0-9]{9})$/.test(value)) {
                            return false;
                        }
                    },
                    message: '请输入正确的联系电话'
                }
            ],
            nation: [{ required: true, message: '请选择办卡人民族' }],

        }
        return {
            loading: false,
            showIdNo: false,
            showNation: false,
            rules,
            renderData: {},
            formObjcet: {
                name: '',
                idNo: '',
                phone: '',
                nation: {},
                address: ''
            }
        };

    },
    created() {
        const { $hdk } = this;
        $hdk.renderData({
            keys: ['nation'],
            data: this.renderData
        });
    },
    methods: {
        nationSelected(value) {
            this.formObjcet.nation = value;
            this.showNation = false;
        },
        submitIdNo() {
            this.showIdNo = false;
        },
        submit() {
            const { formObjcet, $dialog, $router, organId } = this;
            this.loading = true;

            medicalCardApi.registerHealthCard({
                ...formObjcet,
                nation: formObjcet.nation.id,
                organId
            }).then(res => {
                $dialog.alert({
                    message: '注册成功',
                }).then(() => {
                    $router.push({
                        path: '/medical_card/card_list',
                        query: {
                            organId
                        }
                    });
                });
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    props: {
        organId: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    .form {
        .tools {
            position: fixed;
            bottom: 0;
            background-color: @white-color;
            padding: 0.213333rem 0.48rem;
            left: 0;
            right: 0;
            height: 0.933333rem;
            box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
            display: flex;
            align-items: center;
        }
    }

    .remind-text {
        padding: 0.426667rem 0.4rem;
        font-size: 0.373333rem;
        color: @grey-color;
        line-height: 0.64rem;
    }
}
</style>